import 'styles/VerificationLoader.scss';
import { ColorRing } from 'react-loader-spinner';

const VerificationLoader = () => {
    return (<div id="verification-panel">
        <div className="loading">
            <div className="colors-ring">
                <ColorRing
                    colors={['#318616', '#318616', '#318616', '#318616', '#318616']}
                    height={80}
                    width={80}
                    visible={true}
                />
            </div>
            <div className="preloader-text">
                Verifying the voucher code
            </div>
        </div>
    </div>);
}

export default VerificationLoader;